module.exports = __webpack_public_path__ + "img/preview-icon.fbb889a0.svg";